import { useEffect } from 'react';

/**
 * Calls handler when a click occurs outside the referenced element.
 *
 * @param {React.RefObject} ref
 * @param {Function} handler
 *
 * @example
 * const ref = useRef();
 * useClickOutside(ref, () => setOpen(false));
 */
const useClickOutside = (ref, handler) => {
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.target)) return;
      handler(event);
    };

    document.addEventListener('mousedown', listener);
    document.addEventListener('touchstart', listener);

    return () => {
      document.removeEventListener('mousedown', listener);
      document.removeEventListener('touchstart', listener);
    };
  }, [ref, handler]);
};

export default useClickOutside;
